export default function Testimonials() {
  const testimonials = [
    {
      stars: 5,
      headline: 'A masterpiece of modern literature',
      review: 'This author has an extraordinary ability to weave complex narratives that stay with you long after you finish reading. Every character feels real, every emotion palpable.',
      name: 'Sarah Mitchell',
      avatar: 'https://public.readdy.ai/ai/img_res/74dace35ecb8531f22729298c0e34e0c.jpg'
    },
    {
      stars: 5,
      headline: 'Captivating from start to finish',
      review: 'I could not put this book down. The prose is elegant, the storytelling impeccable. This is what great literature should be.',
      name: 'James Anderson',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20man%20headshot%20portrait%20confident%20smile%20simple%20neutral%20background%20clean%20professional%20photo&width=100&height=100&seq=avatar-002&orientation=squarish'
    },
    {
      stars: 5,
      headline: 'Deeply moving and thought-provoking',
      review: 'This work explores the depths of human experience with grace and wisdom. A truly transformative reading experience that I will treasure forever.',
      name: 'Emily Chen',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20woman%20headshot%20portrait%20warm%20smile%20simple%20neutral%20background%20clean%20professional%20photo&width=100&height=100&seq=avatar-003&orientation=squarish'
    },
    {
      stars: 5,
      headline: 'An unforgettable journey',
      review: 'The author crafts worlds so vivid and characters so compelling that you feel like you are living alongside them. Absolutely brilliant storytelling.',
      name: 'Michael Roberts',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20man%20headshot%20portrait%20friendly%20expression%20simple%20neutral%20background%20clean%20professional%20photo&width=100&height=100&seq=avatar-004&orientation=squarish'
    },
    {
      stars: 5,
      headline: 'Beautiful prose and powerful themes',
      review: 'Every sentence is carefully crafted, every theme thoughtfully explored. This is literature at its finest, written by a true master of the craft.',
      name: 'Lisa Thompson',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20woman%20headshot%20portrait%20kind%20smile%20simple%20neutral%20background%20clean%20professional%20photo&width=100&height=100&seq=avatar-005&orientation=squarish'
    },
    {
      stars: 5,
      headline: 'A must-read for book lovers',
      review: 'This author has become one of my all-time favorites. The depth of emotion and the beauty of the writing make every book an absolute treasure.',
      name: 'David Martinez',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20man%20headshot%20portrait%20genuine%20smile%20simple%20neutral%20background%20clean%20professional%20photo&width=100&height=100&seq=avatar-006&orientation=squarish'
    }
  ];

  return (
    <section className="py-32 px-20 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-20">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-2 h-2 rounded-full bg-[#C9A961]"></div>
            <span className="text-xs uppercase tracking-widest text-[#6B6B6B]">Reader Reviews</span>
          </div>
          <h2 className="text-6xl font-bold text-[#2C2C2C] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            What Readers Say
          </h2>
          <p className="text-base text-[#6B6B6B]">
            Testimonials from readers around the world
          </p>
        </div>

        <div className="grid grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 transition-all duration-300 hover:shadow-lg"
              style={{ 
                boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                opacity: index >= 3 ? 0.85 : 1
              }}
            >
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.stars)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C9A961] text-lg"></i>
                ))}
              </div>
              <h3 className="text-xl font-bold text-[#2C2C2C] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                {testimonial.headline}
              </h3>
              <p className="text-base text-[#6B6B6B] leading-relaxed mb-8" style={{ lineHeight: '1.7' }}>
                {testimonial.review}
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-[#E5E5E5]">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img 
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="font-bold text-[#2C2C2C] text-base">{testimonial.name}</div>
                  <div className="text-sm text-[#6B6B6B]">Verified Reader</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
